import { Card, Divider, Grid, IconButton, Switch } from '@mui/material'
import Header from './components/Header'
import Integration from './components/Integration'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Profile from './components/Profile'
import AppSetup from './components/AppSetup'
import AllAppSetup from './components/AllAppSetup'
import DefaultPrompt from './components/DefaultPrompt'
import Defaultassistant from './components/Defaultassistant'
import DefaultCustomePrompt from './components/DefaultCustomePrompt'
import Canny from './components/Canny'
import Workflows from './components/workflow'
import Onboarding from './components/onboarding'
import KnowledgeBase from './components/knowledgebase'
import RemoveAccessModel from './components/RemoveAccessModel'
function Settings() {
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <Grid container mt={10}>
          <Grid item xs={12}>
            <Header
              elements={[
                <Integration />,
                <Onboarding />,
                <KnowledgeBase />,
                <RemoveAccessModel/>,
                <Workflows />,
                <Profile />,
                <Canny />,
              ]}
            />
            {/* <Integration />, <AppSetup />, */}
          </Grid>
        </Grid>
      </DashboardLayout>
    </>
  )
}

export default Settings
